export const seoConfig = {
  'zh-CN': {
    keywords: [
      'FileStation',
      '文件托管',
      '图片托管',
      '云存储',
      '文件上传',
      '文件分享',
      '免费云盘',
      '图片分享',
      '取件码',
      '文件存储',
      '在线存储',
      '文件传输',
      '临时文件',
      '文件中转',
      '快速上传',
      '安全分享'
    ],
    title: 'FileStation - 免费文件托管平台 | 快速上传分享 | 云存储服务',
    description: 'FileStation是一个现代化的文件托管平台，支持图片、视频、文档等多种文件格式的快速上传和分享。提供免费的云存储服务，支持取件码保护，文件自动过期管理，安全可靠。',
    ogTitle: 'FileStation - 免费文件托管平台',
    ogDescription: '支持图片、视频、文档等多种文件格式的快速上传和分享。提供免费的云存储服务，支持取件码保护。',
    twitterDescription: '支持图片、视频、文档等多种文件格式的快速上传和分享。提供免费的云存储服务。',
    locale: 'zh_CN'
  },
  'en-US': {
    keywords: [
      'FileStation',
      'file hosting',
      'image hosting',
      'cloud storage',
      'file upload',
      'file sharing',
      'free cloud storage',
      'image sharing',
      'pickup code',
      'file storage',
      'online storage',
      'file transfer',
      'temporary files',
      'file sharing platform',
      'fast upload',
      'secure sharing'
    ],
    title: 'FileStation - Free File Hosting Platform | Fast Upload & Share | Cloud Storage',
    description: 'FileStation is a modern file hosting platform supporting fast upload and sharing of images, videos, documents, and more. Provides free cloud storage with pickup code protection, automatic file expiration management, secure and reliable.',
    ogTitle: 'FileStation - Free File Hosting Platform',
    ogDescription: 'Supports fast upload and sharing of images, videos, documents, and more. Provides free cloud storage with pickup code protection.',
    twitterDescription: 'Supports fast upload and sharing of images, videos, documents, and more. Provides free cloud storage.',
    locale: 'en_US'
  },
  'ja-JP': {
    keywords: [
      'FileStation',
      'ファイルホスティング',
      '画像ホスティング',
      'クラウドストレージ',
      'ファイルアップロード',
      'ファイル共有',
      '無料クラウド',
      '画像共有',
      'ピックアップコード',
      'ファイル保存',
      'オンラインストレージ',
      'ファイル転送',
      '一時ファイル',
      'ファイル共有プラットフォーム',
      '高速アップロード',
      '安全な共有'
    ],
    title: 'FileStation - 無料ファイルホスティング | 高速アップロード・共有 | クラウドストレージ',
    description: 'FileStationは画像、動画、ドキュメントなど、様々なファイル形式の高速アップロードと共有をサポートするモダンなファイルホスティングプラットフォームです。無料のクラウドストレージを提供し、ピックアップコードによる保護、自動有効期限管理、安全で信頼性の高いサービスです。',
    ogTitle: 'FileStation - 無料ファイルホスティング',
    ogDescription: '画像、動画、ドキュメントなど、様々なファイル形式の高速アップロードと共有をサポートします。無料のクラウドストレージを提供し、ピックアップコードによる保護を提供します。',
    twitterDescription: '画像、動画、ドキュメントなど、様々なファイル形式の高速アップロードと共有をサポートします。無料のクラウドストレージを提供します。',
    locale: 'ja_JP'
  },
  'ko-KR': {
    keywords: [
      'FileStation',
      '파일 호스팅',
      '이미지 호스팅',
      '클라우드 스토리지',
      '파일 업로드',
      '파일 공유',
      '무료 클라우드',
      '이미지 공유',
      '픽업 코드',
      '파일 저장',
      '온라인 스토리지',
      '파일 전송',
      '임시 파일',
      '파일 공유 플랫폼',
      '빠른 업로드',
      '안전한 공유'
    ],
    title: 'FileStation - 무료 파일 호스팅 플랫폼 | 빠른 업로드 및 공유 | 클라우드 스토리지',
    description: 'FileStation은 이미지, 비디오, 문서 등 다양한 파일 형식의 빠른 업로드와 공유를 지원하는 현대적인 파일 호스팅 플랫폼입니다. 무료 클라우드 스토리지를 제공하며, 픽업 코드 보호, 자동 만료 관리, 안전하고 신뢰할 수 있는 서비스를 제공합니다.',
    ogTitle: 'FileStation - 무료 파일 호스팅 플랫폼',
    ogDescription: '이미지, 비디오, 문서 등 다양한 파일 형식의 빠른 업로드와 공유를 지원합니다. 무료 클라우드 스토리지를 제공하며 픽업 코드 보호를 제공합니다.',
    twitterDescription: '이미지, 비디오, 문서 등 다양한 파일 형식의 빠른 업로드와 공유를 지원합니다. 무료 클라우드 스토리지를 제공합니다.',
    locale: 'ko_KR'
  },
  'fr-FR': {
    keywords: [
      'FileStation',
      'hébergement de fichiers',
      'hébergement d\'images',
      'stockage cloud',
      'téléchargement de fichiers',
      'partage de fichiers',
      'stockage cloud gratuit',
      'partage d\'images',
      'code de retrait',
      'stockage de fichiers',
      'stockage en ligne',
      'transfert de fichiers',
      'fichiers temporaires',
      'plateforme de partage de fichiers',
      'téléchargement rapide',
      'partage sécurisé'
    ],
    title: 'FileStation - Plateforme d\'hébergement de fichiers gratuite | Téléchargement rapide et partage | Stockage cloud',
    description: 'FileStation est une plateforme d\'hébergement de fichiers moderne supportant le téléchargement rapide et le partage d\'images, de vidéos, de documents et plus. Fournit un stockage cloud gratuit avec protection par code de retrait, gestion automatique de l\'expiration des fichiers, sécurisé et fiable.',
    ogTitle: 'FileStation - Plateforme d\'hébergement de fichiers gratuite',
    ogDescription: 'Supporte le téléchargement rapide et le partage d\'images, de vidéos, de documents et plus. Fournit un stockage cloud gratuit avec protection par code de retrait.',
    twitterDescription: 'Supporte le téléchargement rapide et le partage d\'images, de vidéos, de documents et plus. Fournit un stockage cloud gratuit.',
    locale: 'fr_FR'
  },
  'de-DE': {
    keywords: [
      'FileStation',
      'Datei-Hosting',
      'Bild-Hosting',
      'Cloud-Speicher',
      'Datei-Upload',
      'Datei-Freigabe',
      'kostenloser Cloud-Speicher',
      'Bild-Freigabe',
      'Abholcode',
      'Dateispeicherung',
      'Online-Speicher',
      'Dateiübertragung',
      'temporäre Dateien',
      'Datei-Freigabe-Plattform',
      'schneller Upload',
      'sichere Freigabe'
    ],
    title: 'FileStation - Kostenlose Datei-Hosting-Plattform | Schneller Upload & Freigabe | Cloud-Speicher',
    description: 'FileStation ist eine moderne Datei-Hosting-Plattform, die schnellen Upload und Freigabe von Bildern, Videos, Dokumenten und mehr unterstützt. Bietet kostenlosen Cloud-Speicher mit Abholcode-Schutz, automatischer Ablaufverwaltung von Dateien, sicher und zuverlässig.',
    ogTitle: 'FileStation - Kostenlose Datei-Hosting-Plattform',
    ogDescription: 'Unterstützt schnellen Upload und Freigabe von Bildern, Videos, Dokumenten und mehr. Bietet kostenlosen Cloud-Speicher mit Abholcode-Schutz.',
    twitterDescription: 'Unterstützt schnellen Upload und Freigabe von Bildern, Videos, Dokumenten und mehr. Bietet kostenlosen Cloud-Speicher.',
    locale: 'de_DE'
  },
  'es-ES': {
    keywords: [
      'FileStation',
      'alojamiento de archivos',
      'alojamiento de imágenes',
      'almacenamiento en la nube',
      'subida de archivos',
      'compartir archivos',
      'almacenamiento en la nube gratuito',
      'compartir imágenes',
      'código de recogida',
      'almacenamiento de archivos',
      'almacenamiento en línea',
      'transferencia de archivos',
      'archivos temporales',
      'plataforma para compartir archivos',
      'subida rápida',
      'compartir seguro'
    ],
    title: 'FileStation - Plataforma de alojamiento de archivos gratuita | Subida rápida y compartir | Almacenamiento en la nube',
    description: 'FileStation es una plataforma moderna de alojamiento de archivos que admite la subida rápida y el intercambio de imágenes, videos, documentos y más. Proporciona almacenamiento en la nube gratuito con protección por código de recogida, gestión automática de caducidad de archivos, seguro y fiable.',
    ogTitle: 'FileStation - Plataforma de alojamiento de archivos gratuita',
    ogDescription: 'Admite la subida rápida y el intercambio de imágenes, videos, documentos y más. Proporciona almacenamiento en la nube gratuito con protección por código de recogida.',
    twitterDescription: 'Admite la subida rápida y el intercambio de imágenes, videos, documentos y más. Proporciona almacenamiento en la nube gratuito.',
    locale: 'es_ES'
  }
}

export const getSeoConfig = (language) => {
  return seoConfig[language] || seoConfig['zh-CN']
}